// Copyright (c) 2024 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
/**
 * Enum for activities.
 */
export var ActivityType;
(function (ActivityType) {
    ActivityType["Gait"] = "Gait";
    ActivityType["Upstairs"] = "Upstairs 2";
    ActivityType["Downstairs"] = "Downstairs 2";
    ActivityType["GolfSwing"] = "Golf swing";
    ActivityType["SitLow"] = "Sit low";
    ActivityType["ChairSitRise"] = "Chair sit rise";
    ActivityType["BendForward"] = "Bend forward";
    ActivityType["SeatedReachToFloor"] = "Seated reach to floor 1";
    ActivityType["TieShoes"] = "Tie shoes";
    ActivityType["CrossedLegSitting"] = "Crossed leg sitting";
    ActivityType["Twist"] = "Twist";
    ActivityType["Pivot"] = "Pivot";
    ActivityType["Extension"] = "extension";
    ActivityType["Flexion"] = "flexion";
    ActivityType["Abduction"] = "abduction";
    ActivityType["Adduction"] = "adduction";
    ActivityType["InternalRotation"] = "internal_rotation";
    ActivityType["ExternalRotation"] = "external_rotation";
    ActivityType["FlexionPlusInternalRotation"] = "flexion_plus_internal_rotation";
    ActivityType["ExternalRotationPlusExtension"] = "external_rotation_plus_extension";
})(ActivityType || (ActivityType = {}));
